// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CaseTemplateEditor_root__7SN8M {
  width: 850px;
  padding: 15px;
  color: var(--color-font-10);
  overflow: scroll;
  margin-right: auto;
  margin-left: auto;
  margin-bottom: 30px;
}

.CaseTemplateEditor_confirm_btn__cAa8f {
  color: var(--color-theme-blue) !important;
  border: 1px solid var(--color-theme-blue) !important;
  width: 174px;
  height: 41px;
  font-weight: bold !important;
}

.CaseTemplateEditor_confirm_btn_container__SUYTL {
  display: inline-flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: space-between;
  align-items: center;
  max-width: 650px;
  min-width: 450px;
  width: 100%;
}

.CaseTemplateEditor_confirm_btn_container_bottom__uVIkY{
  display: inline-flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: space-between;
  align-items: center;
  max-width: 650px;
  min-width: 450px;
  width: 100%;
  margin-top: 15px;
}

.CaseTemplateEditor_currencyRow__MoyeR {
  min-width: 450px;
  max-width: 650px;
}

.CaseTemplateEditor_feeRow__RDWyh {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: space-around;
  align-items: center;
  border: 1px solid DARKGRAY;
  border-radius: 5px;
  padding: 0px 0px 0px 7px;
  margin-top: 10px;
}

.CaseTemplateEditor_feeRowTextInput__b41sG {
  margin-right: 32px !important;
}

.CaseTemplateEditor_mt40__ycPtX{
  margin-top: 40px;
}`, "",{"version":3,"sources":["webpack://./src/@_components/CaseTemplateEditor/CaseTemplateEditor.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;EACb,2BAA2B;EAC3B,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,yCAAyC;EACzC,oDAAoD;EACpD,YAAY;EACZ,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,qBAAqB;EACrB,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,qBAAqB;EACrB,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,qBAAqB;EACrB,6BAA6B;EAC7B,mBAAmB;EACnB,0BAA0B;EAC1B,kBAAkB;EAClB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".root {\n  width: 850px;\n  padding: 15px;\n  color: var(--color-font-10);\n  overflow: scroll;\n  margin-right: auto;\n  margin-left: auto;\n  margin-bottom: 30px;\n}\n\n.confirm_btn {\n  color: var(--color-theme-blue) !important;\n  border: 1px solid var(--color-theme-blue) !important;\n  width: 174px;\n  height: 41px;\n  font-weight: bold !important;\n}\n\n.confirm_btn_container {\n  display: inline-flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  align-content: center;\n  justify-content: space-between;\n  align-items: center;\n  max-width: 650px;\n  min-width: 450px;\n  width: 100%;\n}\n\n.confirm_btn_container_bottom{\n  display: inline-flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  align-content: center;\n  justify-content: space-between;\n  align-items: center;\n  max-width: 650px;\n  min-width: 450px;\n  width: 100%;\n  margin-top: 15px;\n}\n\n.currencyRow {\n  min-width: 450px;\n  max-width: 650px;\n}\n\n.feeRow {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  align-content: center;\n  justify-content: space-around;\n  align-items: center;\n  border: 1px solid DARKGRAY;\n  border-radius: 5px;\n  padding: 0px 0px 0px 7px;\n  margin-top: 10px;\n}\n\n.feeRowTextInput {\n  margin-right: 32px !important;\n}\n\n.mt40{\n  margin-top: 40px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `CaseTemplateEditor_root__7SN8M`,
	"confirm_btn": `CaseTemplateEditor_confirm_btn__cAa8f`,
	"confirm_btn_container": `CaseTemplateEditor_confirm_btn_container__SUYTL`,
	"confirm_btn_container_bottom": `CaseTemplateEditor_confirm_btn_container_bottom__uVIkY`,
	"currencyRow": `CaseTemplateEditor_currencyRow__MoyeR`,
	"feeRow": `CaseTemplateEditor_feeRow__RDWyh`,
	"feeRowTextInput": `CaseTemplateEditor_feeRowTextInput__b41sG`,
	"mt40": `CaseTemplateEditor_mt40__ycPtX`
};
export default ___CSS_LOADER_EXPORT___;
